import { render, staticRenderFns } from "./AdminInfo.vue?vue&type=template&id=ab92b8de&"
import script from "./AdminInfo.vue?vue&type=script&lang=ts&"
export * from "./AdminInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AdminInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports